// extracted by mini-css-extract-plugin
export default {"root":"_3uhG8","text-block":"_1rGdA","textBlock":"_1rGdA","prefix":"_1eHuI"};